export default "__VITE_ASSET__DhnSt_LQ__"